// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"Hero-module--wrapper--4IbCa","video":"Hero-module--video--3QAVd","cta":"Hero-module--cta--jyl4N"};